import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetDealByOpportunityId } from './Deal';
import { getStaleTimeInMinutes } from '@/shared/utils/staleTime.ts';

const STALE_TIME = getStaleTimeInMinutes(5);

export function useDealSuspenseQuery(opportunityId?: string) {
    const { getDealByOpportunityId } = useGetDealByOpportunityId();

    return useSuspenseQuery({
        queryKey: ['deal', opportunityId],
        queryFn: () => (opportunityId ? getDealByOpportunityId(opportunityId) : null),
        staleTime: STALE_TIME,
    });
}
